import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  private readonly errorCodeMap: { [key: string]: string } = {
    '0': 'SALESFORCE.ERRORS.SUCCESS',
    '1001': 'SALESFORCE.ERRORS.CLIENT_CREDENTIALS_REQUIRED',
    '1002': 'SALESFORCE.ERRORS.USERNAME_PASSWORD_REQUIRED',
    '1003': 'SALESFORCE.ERRORS.CLIENT_NOT_FOUND',
    '1004': 'SALESFORCE.ERRORS.INVALID_CLIENT_CREDENTIALS',
    '1005': 'SALESFORCE.ERRORS.INVALID_CREDENTIALS',
    '1006': 'SALESFORCE.ERRORS.ACCOUNT_DISABLED',
    '1007': 'SALESFORCE.ERRORS.SESSION_ID_REQUIRED',
    '1008': 'SALESFORCE.ERRORS.SESSION_NOT_FOUND',
    '1009': 'SALESFORCE.ERRORS.USER_NOT_FOUND',
    '1010': 'SALESFORCE.ERRORS.OTP_REQUIRED',
    '1011': 'SALESFORCE.ERRORS.FAILED_SEND_OTP',
    '1012': 'SALESFORCE.ERRORS.FAILED_SUBMIT_OTP',
    '1013': 'SALESFORCE.ERRORS.INPUT_FIELD_ERRORS',
    '1014': 'SALESFORCE.ERRORS.USER_ALREADY_EXISTS',
    '1015': 'SALESFORCE.ERRORS.FAILED_CREATE_USER',
    '1016': 'SALESFORCE.ERRORS.INVALID_POLICY_MEMBER',
    '1017': 'SALESFORCE.ERRORS.INVALID_PORTAL_ID',
    '1018': 'SALESFORCE.ERRORS.INVALID_POLICY_NUMBER',
    '1019': 'SALESFORCE.ERRORS.INVALID_EMAIL',
    '1020': 'SALESFORCE.ERRORS.POLICY_INACTIVE',
    '1021': 'SALESFORCE.ERRORS.ACCOUNT_TEMPORARILY_DISABLED',
    '1022': 'SALESFORCE.ERRORS.VERIFY_OTP_FIRST',
    '1023': 'SALESFORCE.ERRORS.TERMS_CONDITIONS_REQUIRED',
    '1024': 'SALESFORCE.ERRORS.ACCOUNT_TEMPORARILY_LOCKED',
    '1025': 'SALESFORCE.ERRORS.INVALID_OTP',
    '1026': 'SALESFORCE.ERRORS.AGENT_ACCOUNT_INACTIVE',
    '1027': 'SALESFORCE.ERRORS.MISSING_INVALID_AAJI',
    '1028': 'SALESFORCE.ERRORS.INVALID_AAJI_EXPIRY',
    '1029': 'SALESFORCE.ERRORS.MISSING_EB_CERTIFICATE',
    '1030': 'SALESFORCE.ERRORS.MISSING_STT_LICENSE',
    '1031': 'SALESFORCE.ERRORS.INVALID_STT_EXPIRY',
    '1032': 'SALESFORCE.ERRORS.NO_USER_PROFILE',
    '1033': 'SALESFORCE.ERRORS.INVALID_CREDENTIALS_CHECK',
    '1035': 'SALESFORCE.ERRORS.AUTH_CODE_NOT_FOUND',
    '9999': 'SALESFORCE.ERRORS.INTERNAL_SERVER_ERROR'
  };

  constructor(private translate: TranslateService) {}

  getErrorMessage(errorCode: string, defaultMessage: string): string {
    const translationKey = this.errorCodeMap[errorCode];
    if (translationKey) {
      return this.translate.instant(translationKey);
    }
    return defaultMessage;
  }
}